import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WsService } from 'src/app/modules/core/services/websocket.service';
import { CreateOrUpdateSimulations } from 'src/app/modules/simulation';
import { SimulationService } from 'src/app/modules/simulation/services';
import { SIMULATION_EVENT } from '../../types';

@Component({
    selector: 'stop-simulation-dialog-app',
    templateUrl: 'stop-simulation-dialog.component.html',
    styleUrls: ['./stop-simulation-dialog.component.scss'],
})
export class StopSmulationDialogComponent implements OnInit {
    createOrUpdateModel: CreateOrUpdateSimulations = {
        simulationId: 0,
        actionType: '',
        detailsRequest: {
            name: '',
            startDate: 0,
            startTime: '',
            organizationId: '',
            simulationTypeId: '',
            roomNumber: '',
            participantLogAvailable: null,
        },
        settingsRequest: {
            loginCode: '',
            link: '',
            acceptJoinViaLink: false,
            allowJoinAfterSimulationStarts: false,
            startVideoRecording: false,
            invitePeople: [],
        },
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router,
        public dialog: MatDialog,
        public simulationService: SimulationService,
        private wsService: WsService,
    ) {
        if (this.data?.id) {
            this.simulationService.get(this.data.id).subscribe(result => {
                if (result.data) {
                    this.createOrUpdateModel = {
                        simulationId: this.data.id,
                        actionType: 'end',
                        detailsRequest: {
                            name: result.data.name,
                            startDate: result.data.startDate,
                            startTime: result.data.startTime,
                            organizationId: result.data.organizationId,
                            simulationTypeId: result.data.simulationTypeId,
                            roomNumber: result.data.roomNumber,
                            participantLogAvailable: result.data.participantLogAvailable,
                        },
                        settingsRequest: {
                            loginCode: result.data.loginCode,
                            link: result.data.link,
                            acceptJoinViaLink: Boolean(result.data.acceptJoinViaLink),
                            invitePeople: result.data.invitePeople
                                ? JSON.parse(result.data.invitePeople)?.map((item: any) => {
                                      return {
                                          name: item.Name,
                                          avatar: item.Avatar,
                                          email: item?.Email,
                                      };
                                  })
                                : [],
                            allowJoinAfterSimulationStarts: result.data.allowJoinAfterSimulationStarts
                                ? Boolean(result.data.allowJoinAfterSimulationStarts)
                                : false,
                            startVideoRecording: result.data.startVideoRecording
                                ? Boolean(result.data.startVideoRecording)
                                : false,
                        },
                    };
                }
            });
        }
    }
    ngOnInit(): void {
        const participantStore = localStorage.getItem('participant');
        const participant = participantStore ? JSON.parse(participantStore) : null;
        this.wsService.connect(this.router.url.split('=')[1], participant.participantId);
        this.wsService.messages.subscribe();
    }
    onClickEndSimulation() {
        this.dialog.closeAll();
        this.simulationService.update(this.createOrUpdateModel).subscribe(result => {
            if (result) {
                this.router
                    .navigateByUrl(
                        `/simulation-started?simulationId=${this.createOrUpdateModel.simulationId}&action=edit`,
                    )
                    .then(() => {
                        window.location.reload();
                    });
                const event = {
                    event: SIMULATION_EVENT.SIMULATION_END
                }
                this.wsService.messages.next(
                    JSON.stringify({
                        data: JSON.stringify(event),
                    }),
                );
                this.wsService.messages.error({
                    code: 4000,
                    reason: 'Some thing went wrong. Please contact customer service to support!',
                });
            }
        });
    }
}
